import { useNavigate } from "react-router-dom"
import { Layout } from "../../../../ui/layout"
import Button from "../../../../ui/molecules/button"
import { MenuItems } from "../../../../ui/organisms/navbar/dto"
import { ArrowLeftIcon } from "../../../../ui/icons/arrow-left"
import { PeriodoConversioneAddForms } from "./forms"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { ConversionPeriodCreation } from "../slice"
import { useEffect } from "react"

export function PeriodoConversioneAdd() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const conversionPeriodState = useAppSelector(state => state.conversionPeriod)

    useEffect(() => {
        if(conversionPeriodState.conversionPeriodCreationStatus === 'successfully') {
            navigate('/periodoConversione')
        }
    }, [conversionPeriodState.conversionPeriodCreationStatus])

    return (
        <Layout menuItem={MenuItems.USERS} breadcrumbItems={['Dashboard', 'Gestione Controllo', 'Inserimento Richiesta Periodo di Conversione']}
            noPaddingLat
            headerLabel="Gestione Periodo di conversione"
            headerIcon={
                <button style={{paddingTop: '12px'}} onClick={() => navigate('/periodoConversione')}>
                    <ArrowLeftIcon />
                </button>
            }
            headerChildren={
                <div className="flex items-center h-[100%] w-[100%] justify-end" style={{ justifyContent: 'end' }}>
                    <Button size={"sm"} iconPosition={"off"} variant={"solid"} label="Crea nuovo" color={"orange"}
                        onClick={() => {
                            dispatch(ConversionPeriodCreation(conversionPeriodState.conversionPeriodCreationRequest))
                        }}
                    />
                </div>
            }
        >
            <div>
                <PeriodoConversioneAddForms />
            </div>
        </Layout>
    )
}